import { DocusignConfig } from '@monetize/types/app';
import { useState } from 'react';
import { SettingCardEdit } from '../../../../../components/Settings/SettingCardEdit';
import { SettingCardView } from '../../../../../components/Settings/SettingCardView';
import DocusignForm from './DocusignForm';

interface DocusignConnectionProps {
  connection: DocusignConfig;
}

const DocusignConnection = ({ connection }: DocusignConnectionProps) => {
  const [mode, setMode] = useState<'VIEW' | 'EDIT'>('VIEW');

  return (
    <>
      {mode === 'VIEW' && (
        <SettingCardView
          status={'ACTIVE'}
          actions={[]}
          type="Docusign"
          tags={[
            {
              label: 'User ID',
              value: connection.userId,
              colSpan: 1,
            },
            {
              label: 'Environment',
              value: connection.accountBaseURI,
              colSpan: 1,
            },
            {
              label: 'HMAC Key / Secret Connect Key',
              value: connection.hmacKey,
              colSpan: 1,
            },
            {
              label: 'Account ID',
              value: connection.accountId || '',
              colSpan: 1,
            },
          ]}
          onEdit={() => setMode('EDIT')}
          onAction={() => {}}
        />
      )}
      {mode === 'EDIT' && (
        <SettingCardEdit type="Docusign">
          <DocusignForm esign={connection} onClose={() => setMode('VIEW')} />
        </SettingCardEdit>
      )}
    </>
  );
};

export default DocusignConnection;
